// Browser-public configuration, baked in at build time. The anon/publishable key is
// designed to be public; RLS and the RPC boundary protect the data.
import { isAccountMode, parseMode, type PtwMode } from './identity'

export const env = {
  supabaseUrl: (import.meta.env.VITE_SUPABASE_URL as string | undefined) ?? '',
  supabaseAnonKey: (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ?? '',
  /** 'synthetic_demo' (personas), 'staging' or 'operational' (real accounts, email codes). */
  mode: parseMode(import.meta.env.VITE_PTW_MODE as string | undefined) as PtwMode,
}

export const isConfigured = Boolean(env.supabaseUrl && env.supabaseAnonKey)
export const isDemoMode = env.mode === 'synthetic_demo'
/** Real accounts: email one-time-code sign-in for invited people only (0022). */
export const isAccountBuild = isAccountMode(env.mode)
